import React from "react";
import Skeleton from 'react-loading-skeleton';

export default function MyPetCardSkeleton() {
    return (
        <div className="flex flex-col gap-3">
            {/* Image Skeleton */}
            <div className="aspect-square w-full">
                <Skeleton height="100%" />
            </div>
            
            {/* Content Skeleton */}
            <div className="flex flex-col gap-2">
                <Skeleton width="66%" height={16} />
                <Skeleton width="50%" height={12} />
            </div>
        </div>
    );
}
